export enum OrderType {
  // POPULAR = 'id|desc',
  BEST_SELLER = 'sku|desc',
  POPULAR = 'special|sorting',
  HIGH_PRICE = 'price|desc',
  LOW_PRICE = 'price|asc',
}

export const PAGE_SIZE = 48;
